import type { MatchSides } from "@/pages/matches/components/details/sides";
import { fmtStat, homeShare } from "@/pages/sports/lib/format";
import type { IMatchStat } from "@/types/match-details";

/** Statistics as home-vs-away rows: the home value, the label over a share bar, the away value. */
export function MatchStatistics({
  stats,
  sides,
}: {
  stats: IMatchStat[];
  sides: MatchSides;
}) {
  return (
    <ul className="flex flex-col gap-2.5">
      <li className="flex justify-between text-xs font-medium text-muted-foreground">
        <span>{sides.homeName ?? "Home"}</span>
        <span>{sides.awayName ?? "Away"}</span>
      </li>
      {stats.map((stat, i) => {
        const share = homeShare(stat.home, stat.away);
        return (
          <li
            key={stat.key ?? i}
            className="grid grid-cols-[4rem_1fr_4rem] items-center gap-3 text-sm"
          >
            <span className="text-right font-medium tabular-nums">
              {fmtStat(stat, stat.home, stat.away)}
            </span>
            <div className="flex flex-col gap-1">
              <span className="text-center text-xs text-muted-foreground">
                {stat.label ?? stat.key}
              </span>
              {share !== undefined && (
                <div className="h-1 overflow-hidden rounded bg-muted">
                  <div
                    className="h-full bg-primary"
                    style={{ width: `${share}%` }}
                  />
                </div>
              )}
            </div>
            <span className="font-medium tabular-nums">
              {fmtStat(stat, stat.away, stat.home)}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
